import { render, staticRenderFns } from "./LocationDetails.vue?vue&type=template&id=f1e38aa8&scoped=true&"
import script from "./LocationDetails.vue?vue&type=script&lang=js&"
export * from "./LocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./LocationDetails.vue?vue&type=style&index=0&id=f1e38aa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e38aa8",
  null
  
)

export default component.exports